import * as React from "react";

import {faClose}             from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}     from "@fortawesome/react-fontawesome";
import {DateRangePicker}     from "@Xpresso/routes/common/date-range-picker/date-range-picker";
import {Select}              from "@Common/ui-components/heavy/common/design2/select/select";
import {xdQAattribute}       from "../analytics-layout";
import "./analytics-advanced-search.scss";

export const AnalyticsAdvancedSearch = ({
    filterLists,
    setPageIndex,
    filters, setFilters, 
    startDate, setStartDate,
    endDate, setEndDate, 
    showAdvancedSearch, setShowAdvancedSearch, 
}) => {

    const updateFilters = (key, value) => {
        const tempFilters = [...filters]
        const existingObject = tempFilters.find(object => object.filterKey === key)
        if(!existingObject) {
            tempFilters.push({filterKey: key, values: [value]})
            setFilters(tempFilters)
            setPageIndex(0)
            return 
        }
        
        if(!existingObject.values.includes(value)) {
            existingObject.values.push(value)
        }
        setFilters(tempFilters)
        setPageIndex(0)
    }

    const removeFilterByKey = (filterKey, valueIndex) => {
        const tempFilters = [...filters]
        const filterRemove = tempFilters?.find(filter => filter.filterKey === filterKey)
        filterRemove.values.splice(valueIndex, 1)
        
        if(filterRemove.values.length > 0) {
            setFilters(tempFilters)
            setPageIndex(0)
            return
        } 

        const index = tempFilters.findIndex(filter => filter.filterKey === filterKey)
        if(index !== -1) {
            tempFilters.splice(index, 1)
        }
        setFilters(tempFilters)
        setPageIndex(0)
    }

    const removeFilterKey = (filterKey) => {
        const tempFilters = [...filters]
        const index = tempFilters.findIndex(filter => filter.filterKey === filterKey)
        if(index !== -1) {
            tempFilters.splice(index, 1)
        }
        setFilters(tempFilters)
        setPageIndex(0)
    }

    const startDateWrapper = {
        value: startDate,
        onChange: setStartDate
    }

    const endDateWrapper = {
        value: endDate,
        onChange: setEndDate
    }

    return (
        <div className={`advanced-search-dznts2 ${showAdvancedSearch ? "" : " collapsed"}`}
            onClick={() => {
                if(showAdvancedSearch) {
                    setShowAdvancedSearch(false)
                }
            }}
        >
            <div className="advanced-search"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="advanced-search-header">
                    <h5 className="advanced-search-title">Advanced Search</h5>
                    <FontAwesomeIcon
                        className="icon" 
                        icon={faClose}
                        onClick={() => setShowAdvancedSearch(false)}
                        {...xdQAattribute('icon', 'close advanced search')}
                    />
                </div>
                <div className="filter-select-container">
                {
                    filterLists.map((filterList) => {
                        const filtersCurrent = filters?.find(filter => filter.filterKey === filterList.filterKey)
                        const filteredList = filtersCurrent 
                            ? filterList.values.filter(value => {
                                return !filtersCurrent.values.includes(value)
                            })
                            : filterList.values
                        return (
                            <div 
                                className='select-container'
                                key={filterList.filterKey}
                            >
                            { 
                                Select({
                                    list: sortedFilterList(filteredList),
                                    onChange: (value) => {
                                        updateFilters(filterList.filterKey, value)
                                    },
                                    isSelected: (item) => null,
                                    className: `select ${filterList.filterKey}`,
                                    xdQaName: filterList.filterKey,
                                })
                            }
                            {
                                filtersCurrent
                                ? <div className="filters-container">
                                        <div className="filters-current">
                                            {
                                                filtersCurrent.values.map((value, j) => {
                                                    return (
                                                        <div 
                                                            className="filter-value"
                                                            key={j}
                                                        >
                                                            <p>{value}</p>
                                                            <FontAwesomeIcon
                                                                className="icon" 
                                                                icon={faClose}
                                                                onClick={() => removeFilterByKey(filtersCurrent.filterKey, j)}
                                                                {...xdQAattribute('icon', `remove filter ${value}`)}
                                                            />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <a 
                                            className="clear-filters"
                                            onClick={() => removeFilterKey(filtersCurrent.filterKey)}
                                            {...xdQAattribute('link', `remove all filters ${filtersCurrent.filterKey}`)}
                                        >
                                            Clear
                                        </a>
                                    </div>
                                : <div 
                                    className="select-label"
                                    {...xdQAattribute('label', filterList.filterKey)}
                                >
                                    {labelFromKey(filterList.filterKey)}
                                </div>
                            }
                            </div>
                        )
                    })
                }
                {
                    DateRangePicker({
                        startDate: startDateWrapper,
                        endDate: endDateWrapper
                    })
                }
                </div>
            </div>
        </div>
       
    )
}

const sortedFilterList = (filteredList) => {
    if(typeof filteredList[0] === "number") {
        return filteredList.sort()
    }

    return filteredList.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
}

const labelFromKey = (key) => {
    let label = key.charAt(0).toUpperCase() + key.slice(1)
    label = label.replace(/([a-z])([A-Z])/g, '$1 $2')
    return label
}